import { render, staticRenderFns } from "./ResponsibleField.vue?vue&type=template&id=366df099&"
import script from "./ResponsibleField.vue?vue&type=script&lang=js&"
export * from "./ResponsibleField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports